import { jsx } from '@amazon/vinyl-tsx'
import { Icon } from '@/components/Icon'
import { getString } from '@/auth/i18n/bundle.generated'

/**
 * Full-screen block shown at app load when the invite gate denies access
 * (no valid `?invite=` token and no sticky unlock). Mirrors SignInWall's
 * hero-mark + message layout but carries no sign-in button — access is
 * gated on the invite link, not on being signed in.
 */
export function InviteRequiredWall() {
    return (
        <div className="signInWall" aria-label={getString('dmusic_invite_gate_absent')}>
            <div className="signInWallHero" aria-hidden="true">
                <Icon icon="amazonMusic" className="signInWallHeroIcon" />
            </div>
            <p className="signInWallSubtitle">{getString('dmusic_invite_gate_absent')}</p>
        </div>
    )
}
